import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NotificationContextType {
  ticketsNotificationVisible: boolean;
  docsNotificationVisible: boolean;
  setTicketsNotificationVisible: (visible: boolean) => void;
  setDocsNotificationVisible: (visible: boolean) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const useNotificationCoordinator = (): NotificationContextType => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationCoordinator must be used within a NotificationProvider');
  }
  return context;
};

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const [ticketsNotificationVisible, setTicketsNotificationVisibleInternal] = useState(false);
  const [docsNotificationVisible, setDocsNotificationVisibleInternal] = useState(false);

  // Función para controlar notificación de tickets (oculta la de docs si es necesario)
  const setTicketsNotificationVisible = (visible: boolean) => {
    if (visible && docsNotificationVisible) {
      setDocsNotificationVisibleInternal(false);
    }
    setTicketsNotificationVisibleInternal(visible);
  };

  // Función para controlar notificación de docs (oculta la de tickets si es necesario)
  const setDocsNotificationVisible = (visible: boolean) => {
    if (visible && ticketsNotificationVisible) {
      setTicketsNotificationVisibleInternal(false);
    }
    setDocsNotificationVisibleInternal(visible);
  };

  return (
    <NotificationContext.Provider
      value={{
        ticketsNotificationVisible,
        docsNotificationVisible,
        setTicketsNotificationVisible,
        setDocsNotificationVisible,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
}; 